export default __webpack_public_path__ + "static/media/about-sm-lear2.c71d5f40.svg";